import { useMemo } from "react";
import { MaterialTransferido } from "../interfaces";
import { MRT_ColumnDef } from "material-react-table";

import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import CustomCantidadInput from "../components/ui/CustomCantidadInput";
import { Delete } from "@mui/icons-material";

import { IconButton, Tooltip } from "@mui/material";

export const useTableColumnsSolicitudIngreso = () => {
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleEliminarProdcuto = useCargarSeriesProductos(s => s.handleEliminarProducto)


  const columnsInfoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'Codigo'
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción'
    },
    {
      accessorKey: 'producto_data.unidad_medida',
      header: 'Unidad Medida',
      Cell: ({ row }) => row.original.producto_data?.unidad_medida || 'N/A'
    },
    {
      accessorKey: 'producto_data.presentacion',
      header: 'Presentación',
      Cell: ({ row }) => row.original.producto_data?.presentacion || 'N/A'
    },
    {
      accessorKey: 'producto_data.stock_actual',
      header: "Stock Actual"
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria_producto'
    },
  ], [])
  const columnsSolicitudIngreso = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => {
        return (
          <Tooltip title="Eliminar">
            <IconButton
              onClick={() => {
                handleEliminarProdcuto(row.original.id)
              }}
            >
              <Delete color="error" />
            </IconButton>

          </Tooltip>

        )
      }
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad Requerida',
      size: 190,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      )
    },


    ...columnsInfoProducto
  ], [])
  return {
    columnsSolicitudIngreso
  }
}
export default useTableColumnsSolicitudIngreso;